import {
  COLOR_RESOURCE_TAG_TAG_BG,
  COLOR_RESOURCE_TAG_TAG_BORDER,
  COLOR_RESOURCE_TAG_TAG_TEXT,
} from '../colors';

export const TAG_BADGE_STYLE = {
  backgroundColor: COLOR_RESOURCE_TAG_TAG_BG,
  color: COLOR_RESOURCE_TAG_TAG_TEXT,
  borderColor: COLOR_RESOURCE_TAG_TAG_BORDER,
};
